export const baseChipSx = {
  display: 'flex',
  alignItems: 'center',
  px: 1,
  py: 1.6,
  backgroundColor: 'transparent',
};

export const baseLabelSx = {
  fontSize: '0.85rem',
  fontWeight: 'normal',
  lineHeight: 1.2,
};
